<template>
    <div class="card bank-transfer-instructions">
        <div class="card-body">
            <div class="text-center lead mb-3">{{$t(`payment.reason.${link.reason}`)}}</div>
            <branded-divider v-if="link.paymentAmount" class="my-4">
                <div class="d-flex align-items-center">
                    <h3 class="mb-0 text-secondary me-2">{{$filters.beautifyCurrency(link.paymentAmount)}}</h3>
                    <div class="lead"><small>{{$t('payment.paymentDue')}}</small></div>
                </div>
            </branded-divider>
            <accent-box v-if="link.notes" :title="$t('payment.noteFromTravelAdvisor')" class="smaller my-4">
                <font-awesome-icon class="text-secondary me-1" :icon="['fas', 'quote-left']" />
                <span class="mx-1" style="white-space: pre-wrap;">{{link.notes}}</span>
                <font-awesome-icon class="text-secondary ms-1" :icon="['fas', 'quote-right']" />
            </accent-box>
            <h3>{{$t('payment.bankTransferInstructions.bankTransferInstructions')}}</h3>
            <div class="lead mb-3">{{$t('payment.bankTransferInstructions.bankTransferInstructionDetails')}}</div>
            <div class="row">
                <div class="col-xl-7 mb-3">
                    <accent-box title="Bank Information">
                        <div class="row">
                            <div class="col-4">{{$t('payment.bankTransferInstructions.bankName')}}</div>
                            <div class="col"><strong>{{trip.brand.bankName}}</strong></div>
                        </div>
                        <div class="row">
                            <div class="col-4">{{$t('payment.bankTransferInstructions.accountName')}}</div>
                            <!--TODO Hard coded ", Inc." appended to company name. Add a legal name to the brand table and use that instead. -->
                            <div class="col"><strong>{{trip.brand.company}}, Inc.</strong></div>
                        </div>
                        <div class="row">
                            <div class="col-4 pe-0">{{$t('payment.bankTransferInstructions.accountNumber')}}</div>
                            <div class="col"><strong>{{trip.brand.bankAccountNumber}}</strong></div>
                        </div>
                        <div class="row">
                            <div class="col-4">{{$t('payment.bankTransferInstructions.achRoutingNumber')}}</div>
                            <div class="col"><strong>{{trip.brand.bankAchTransferRoutingNumber}}</strong></div>
                        </div>
                        <div class="row">
                            <div class="col-4">{{$t('payment.bankTransferInstructions.wireRoutingNumber')}}</div>
                            <div class="col"><strong>{{trip.brand.bankWireTransferRoutingNumber}}</strong></div>
                        </div>
                        <div class="row">
                            <div class="col-4">{{$t('payment.bankTransferInstructions.swiftCode')}}</div>
                            <div class="col"><strong>{{trip.brand.bankWireTransferSwiftCode}}</strong></div>
                        </div>
                        <div class="row">
                            <div class="col-4">{{$t('payment.bankTransferInstructions.accountAddress')}}</div>
                            <div class="col"><strong>{{trip.brand.streetAddress}}, {{trip.brand.city}} {{trip.brand.state}} {{trip.brand.postalCode}}</strong></div>
                        </div>
                        <div class="row">
                            <div class="col-4">{{$t('payment.bankTransferInstructions.bankAddress')}}</div>
                            <div class="col"><strong>{{trip.brand.bankAddress}}</strong></div>
                        </div>
                        <div class="row">
                            <div class="col-4">{{$t('payment.phoneNumber')}}</div>
                            <div class="col"><strong>{{trip.brand.bankPhone}}</strong></div>
                        </div>
                        <div class="text-center small mt-1">{{$t('payment.bankTransferInstructions.otherCurrencyWireTransferNote')}}</div>
                    </accent-box>
                </div>
                <div class="col-xl-5 mb-3">
                    <accent-box :title="`${trip.brand.company} ${$t('payment.bankTransferInstructions.accountingContact')}`">
                        <div class="lead">{{trip.brand.accountingName}}</div>
                        <div>
                            <font-awesome-icon :icon="['fal', 'square-envelope']" class="fa-lg text-dark me-1"/>
                            <span>
                                <a :href="`mailto:${trip.brand.accountingEmail}`" class="ps-1">{{trip.brand.accountingEmail}}</a>
                            </span>
                        </div>
                        <div>
                            <font-awesome-icon :icon="['fal', 'square-phone']" class="fa-lg text-dark me-1"/>
                            {{trip.brand.accountingPhone}}
                        </div>
                    </accent-box>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccentBox from '@/components/common/AccentBox';
import BrandedDivider from '@/components/common/BrandedDivider';

export default {
    name: 'BankTransferInstructions',
    components: {
        AccentBox,
        BrandedDivider
    },
    props: {
        link: {
            type: Object,
            required: true
        },
        trip: {
            type: Object,
            required: true
        },
    }
};
</script>